module.exports = __webpack_public_path__ + "img/410f09ac649c5880967dad787640ebb6.png";